import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import LandingPage from "@/pages/LandingPage";
import ChildSafety from "@/pages/ChildSafety";
import { Toaster } from "@/components/ui/sonner";

function SmoothScrollProvider({ children }) {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
  return children;
}

export default function App() {
  return (
    <div className="App">
      <SmoothScrollProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/securite-des-enfants" element={<ChildSafety />} />
          </Routes>
        </BrowserRouter>
      </SmoothScrollProvider>
      <Toaster
        position="bottom-center"
        theme="light"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#ffffff",
            border: "none",
            borderRadius: "999px",
            padding: "12px 22px",
            fontFamily: "Manrope, sans-serif",
            fontSize: "14px",
          },
        }}
      />
    </div>
  );
}
